"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetlistValidationResultSchema = exports.NetlistValidationSummarySchema = exports.UnknownDesignatorsSchema = exports.OracleUnknownConnectionsSchema = exports.OracleRejectedRowsSchema = exports.NetlistValidationErrorSchema = exports.NetConnectionSchema = exports.NO_CONNECT_PLACEHOLDER_NET_NAME = exports.NetlistValidationErrorType = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const netlist_gate_1 = require("../Types/netlist-gate");
var NetlistValidationErrorType;
(function (NetlistValidationErrorType) {
    NetlistValidationErrorType["NetNameMismatch"] = "NetNameMismatch";
    NetlistValidationErrorType["MissingModuleConnection"] = "MissingModuleConnection";
    NetlistValidationErrorType["UnexpectedProjectModelNet"] = "UnexpectedProjectModelNet";
    NetlistValidationErrorType["UnexpectedNetFound"] = "UnexpectedNetFound";
    NetlistValidationErrorType["UnexpectedConnection"] = "UnexpectedConnection";
    NetlistValidationErrorType["ModuleNotFoundInNetlist"] = "ModuleNotFoundInNetlist";
    NetlistValidationErrorType["ValidationError"] = "ValidationError";
    NetlistValidationErrorType["MissingModule"] = "MissingModule";
})(NetlistValidationErrorType || (exports.NetlistValidationErrorType = NetlistValidationErrorType = {}));
exports.NO_CONNECT_PLACEHOLDER_NET_NAME = '?';
exports.NetConnectionSchema = zod_1.z.object({
    moduleName: zod_1.z.string(),
    pinRef: zod_1.z.string(),
    pinFunction: zod_1.z.string().optional(),
});
exports.NetlistValidationErrorSchema = zod_1.z
    .object({
    type: zod_1.z.nativeEnum(NetlistValidationErrorType),
    message: zod_1.z.string(),
    severity: zod_1.z.nativeEnum(sigma_engine_shared_1.BoundaryLevel).optional(),
    projectNetName: zod_1.z.string().optional(),
    netlistNetName: zod_1.z.string().optional(),
    moduleName: zod_1.z.string().optional(),
    pinRef: zod_1.z.string().optional(),
    connections: exports.NetConnectionSchema.array().optional(),
    actualConnections: exports.NetConnectionSchema.array().optional(),
})
    .passthrough();
exports.OracleRejectedRowsSchema = zod_1.z.object({
    lineNumbers: zod_1.z.number().array(),
});
exports.OracleUnknownConnectionsSchema = zod_1.z.object({
    connections: exports.NetConnectionSchema.array(),
});
exports.UnknownDesignatorsSchema = zod_1.z.object({
    count: zod_1.z.number(),
    matchedInOtherForm: zod_1.z.number(),
});
exports.NetlistValidationSummarySchema = zod_1.z.object({
    totalNetsChecked: zod_1.z.number(),
    totalErrorsFound: zod_1.z.number(),
    netNameMismatches: zod_1.z.number(),
    missingConnections: zod_1.z.number(),
    missingNets: zod_1.z.number(),
    missingModules: zod_1.z.number(),
    unexpectedNets: zod_1.z.number(),
    oracleRejectedRows: exports.OracleRejectedRowsSchema.optional(),
    oracleUnknownConnections: exports.OracleUnknownConnectionsSchema.optional(),
    unknownDesignators: exports.UnknownDesignatorsSchema.optional(),
});
exports.NetlistValidationResultSchema = zod_1.z
    .object({
    type: zod_1.z.literal('NetlistValidation'),
    message: zod_1.z.string(),
    severity: zod_1.z.nativeEnum(sigma_engine_shared_1.BoundaryLevel).optional(),
    errors: exports.NetlistValidationErrorSchema.array(),
    netlistSource: zod_1.z.nativeEnum(netlist_gate_1.NetlistSource).optional(),
    summary: exports.NetlistValidationSummarySchema,
})
    .passthrough();
//# sourceMappingURL=types.js.map